import clsx from 'clsx';
import { ReactNode } from 'react';
import { Placement } from 'react-aria';
import Icon, { IconProps } from '~/components/data-display/Icon';
import Text from '~/components/typographies/Text';
import IconInfo from '~/icons/icon-info-round-stroke.svg?react';
import styles from './InfoIconTooltip.module.scss';
import SimpleTooltip, { SimpleTooltipProps } from './data-display/SimpleTooltip';
import { HStack } from './layout/Stack';

const Title = ({
  text,
  contentClassName,
  hideIcon = false,
}: {
  text?: string | ReactNode;
  contentClassName?: string;
  hideIcon?: boolean;
}) => {
  return (
    <HStack gap={1} className={clsx(styles.tooltipContent, contentClassName)} align="center">
      {!hideIcon && <Icon component={IconInfo} size="sm" className={styles.tooltipIcon} />}
      <div>
        {typeof text === 'string' ? (
          <Text variant="body2" weight="regular">
            {text}
          </Text>
        ) : (
          text
        )}
      </div>
    </HStack>
  );
};

interface InfoIconTooltipProps {
  text?: string | ReactNode;
  color?: string;
  contentClassName?: string;
  placement?: Placement;
  theme?: SimpleTooltipProps['theme'];
  hideTooltipIcon?: boolean;
  iconSize?: IconProps['size'];
}

const InfoIconTooltip = ({
  text,
  color,
  contentClassName,
  placement = 'top start',
  theme = 'light',
  hideTooltipIcon = false,
  iconSize = 'sm',
}: InfoIconTooltipProps) => {
  return (
    <SimpleTooltip
      title={<Title text={text} hideIcon={hideTooltipIcon} contentClassName={contentClassName} />}
      placement={placement}
      theme={theme}
    >
      <Icon component={IconInfo} size={iconSize} color={color} className={styles.anchorIcon} />
    </SimpleTooltip>
  );
};

export default InfoIconTooltip;
